<div class="branding-container">
  <app-branding-logo class="branding-column" />
  <!-- <app-branding-product class="branding-column" /> -->
</div>
